import React, { useContext } from 'react';
import { FilterBarContext, FilterFieldName } from '../FilterBarContext';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, IconButton } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { TransactionStatus } from '@/modules/transactions/api/transactions/transaction.contracts';
import { useTranslation } from '@/lib';
import { getTransactionStatusStyle } from '@/modules/transactions/types/TransactionModel';

interface TransactionStatusFilterProps {
  label: string;
}

const TransactionStatusFilter: React.FC<TransactionStatusFilterProps> = ({ label }) => {
  const { setFilterValue, filterValues } = useContext(FilterBarContext);
  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    if (value === '') {
      setFilterValue(FilterFieldName.transactionStatus, undefined);
    } else {
      const transactionStatus = value as TransactionStatus;
      // Get the human-readable translation (capitalized)
      const humanValue = t(transactionStatus.toLowerCase());
      setFilterValue(FilterFieldName.transactionStatus, transactionStatus, humanValue);
    }
  };

  const handleClear = () => {
    setFilterValue(FilterFieldName.transactionStatus, undefined);
  };

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        value={filterValues.transactionStatus || ''}
        onChange={handleChange}
        label={label}
        endAdornment={
          filterValues.transactionStatus && (
            <IconButton className="absolute right-3 mr-6 flex" color="inherit" onClick={handleClear} aria-label="clear" size="small">
              <Clear />
            </IconButton>
          )
        }
      >
        <MenuItem value={TransactionStatus.InProgress}>
          <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${
              getTransactionStatusStyle(TransactionStatus.InProgress).bg
            } ${getTransactionStatusStyle(TransactionStatus.InProgress).text}`}
          >
            {t('in_progress')}
          </span>
        </MenuItem>
        <MenuItem value={TransactionStatus.Finalized}>
          <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${
              getTransactionStatusStyle(TransactionStatus.Finalized).bg
            } ${getTransactionStatusStyle(TransactionStatus.Finalized).text}`}
          >
            {t('finalized')}
          </span>
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default TransactionStatusFilter;
